<template>
  <DBox :id="'cmp-catalog-tracks-sidewindow-track_setup'" :addButton="false">
    <TextField2
      :disabled="selectedLabelDetails.disabled"
      :id="'label_name'"
      :placeholder="$t('label_name')"
      :label="$t('label_name')"
      :value="selectedLabelDetails.label.label_name"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :disabled="selectedLabelDetails.disabled"
      :id="'short_name'"
      :placeholder="$t('short_name_string')"
      :label="$t('short_name_string')"
      :value="selectedLabelDetails.label.short_name"
      @blur="onTextFieldValueChange"
    />
    <Dropdown2
      :disabled="selectedLabelDetails.disabled"
      :label="$t('type')"
      :placeholder="$t('type')"
      :options="selectedLabelDetails.labelTypesTV"
      :selected="
        selectedLabelDetails.labelTypesTV.find(
          e => e.value == selectedLabelDetails.label.label_type
        )
      "
      deselect
      v-on:selectedChange="e => onDropdownChange('label_type', e)"
    />

    <DatePicker2
      :disabled="false"
      v-if="selectedLabelDetails.label.termination_date"
      id="termination_date"
      :label="'Termination Date'"
      :value="selectedLabelDetails.label.termination_date"
      @input="(e) => onDateChange(e)"
    />
    <!-- {{ selectedLabelDetails.statusTV }} -->
    <Dropdown2
      :disabled="selectedLabelDetails.disabled"
      :label="$t('status')"
      :placeholder="$t('status')"
      :options="selectedLabelDetails.statusTV"
      :selected="
        selectedLabelDetails.statusTV.find(
          e => e.value == selectedLabelDetails.label.label_status_id
        )
      "
      deselect
      v-on:selectedChange="e => onDropdownChange('label_status_id', e)"
    />
    <TextField2
      :disabled="selectedLabelDetails.disabled"
      :id="'default_p_line'"
      :placeholder="$t('default_p_line')"
      :label="$t('default_p_line')"
      :value="selectedLabelDetails.label.default_p_line"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :disabled="selectedLabelDetails.disabled"
      :id="'default_c_line'"
      :placeholder="$t('default_c_line')"
      :label="$t('default_c_line')"
      :value="selectedLabelDetails.label.default_c_line"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :disabled="selectedLabelDetails.disabled"
      :id="'url1'"
      :placeholder="$t('url')"
      :label="$t('url')"
      :value="selectedLabelDetails.label.url1 || ''"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :disabled="selectedLabelDetails.disabled"
      :id="'url2'"
      :placeholder="$t('url2')"
      :label="$t('url2')"
      :value="selectedLabelDetails.label.url2 || ''"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :disabled="selectedLabelDetails.disabled"
      :id="'isrc_base'"
      :placeholder="$t('isrc_base')"
      :label="$t('isrc_base')"
      :value="selectedLabelDetails.label.isrc_base"
      @blur="onTextFieldValueChange"
    />
    <TextField2
      :disabled="selectedLabelDetails.disabled"
      :id="'label_code'"
      :placeholder="$t('label_code')"
      :label="$t('label_code')"
      :value="selectedLabelDetails.label.label_code"
      :bb="'0px'"
      @blur="onTextFieldValueChange"
    />
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";

export default {
  components: {
    DBox
  },
  props: ["selectedLabelDetails"],
  methods: {
    onTextFieldValueChange: function(event) {
      const { name, value } = event;
      this.$emit("changed", { name, value });
    },
    onDropdownChange: function(name, value) {
      // console.log('name', name, value.value);
      this.$emit("changed", { name, value: value.value });
    },
    onDateChange: async function (e) {
      const payload = {
        name: e.name,
        value: e.value,
      };
        this.$emit("changed", payload);

      console.log("WERERTYUPOIUN", payload);
    },
  }
};
</script>

<style lang="scss">
.cmp-catalog-tracks-sidewindow-track_setup {
  .fc2-row {
    --fc2-tf-padding: 0px 10px;
    --fc2-tf-margin: 3px 3px 3px 0px;
    --bb: 1px solid var(--sprt-85);

    height: 30px;
    border-bottom: var(--bb);

    .fc2-label,
    .icon,
    .title {
      flex: 1;
    }
    .fc2-label,
    .title-txt {
      max-width: 115px;
    }
    > .ut-flex {
      flex: 1;
      padding: var(--fc2-tf-padding);
      margin: var(--fc2-tf-margin);
      min-width: 0;
      outline: none;

      span {
        display: block;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        cursor: pointer;
        text-decoration: underline;
        &:hover {
          text-decoration: none;
        }
      }
    }
    .icon {
      min-height: 22px;
      justify-content: flex-end;
    }
  }
}
</style>
